module.exports = __webpack_public_path__ + "assets/img/37_1633_big.54f11668.jpg";